import { render } from "./TelehealthPatientIos.vue?vue&type=template&id=48bce640&ts=true"
import script from "./TelehealthPatientIos.vue?vue&type=script&lang=ts"
export * from "./TelehealthPatientIos.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__